import { apiClient } from "@/lib/axios"

const AUTH_URL = import.meta.env.VITE_AUTH_URL ?? ""

/**
 * Presença de sessões (sigi-auth): heartbeat de ~60s enquanto há sessão
 * ativa e lista admin de "usuários logados". A chave expira sozinha no
 * backend (TTL, ver sigi.presence.ttl) — sem heartbeat, a sessão sai da
 * lista.
 */

/** Sessão ativa exposta por GET /api/v1/presenca (admin). */
export interface SessaoAtiva {
  usuario: string | null
  nome: string | null
  email: string | null
  ip: string
  aplicacao: string | null
  /** Epoch millis do último heartbeat (relógio do servidor). */
  vistoEmMs: number
}

/** Lista as sessões ativas (admin-only). */
export async function listarSessoes(): Promise<SessaoAtiva[]> {
  const { data } = await apiClient.get<SessaoAtiva[]>(`${AUTH_URL}/api/v1/presenca`)
  return data
}

/** Renova a presença do usuário autenticado (best-effort no front). */
export async function registrarHeartbeat(): Promise<void> {
  await apiClient.post(`${AUTH_URL}/api/v1/presenca/heartbeat`)
}

/**
 * Remove a própria presença no fecho da aba/logout — `keepalive` sobrevive
 * ao unload. Melhor esforço: em dev cross-origin o preflight pode não
 * completar; o TTL da chave no backend cobre o caso.
 */
export async function sairPresenca(token: string | null): Promise<void> {
  if (!token) return
  try {
    await fetch(`${AUTH_URL}/api/v1/presenca`, {
      method: "DELETE",
      keepalive: true,
      headers: { Authorization: `Bearer ${token}` },
    })
  } catch {
    // sem token/erro de rede: o TTL da chave encerra a presença
  }
}
